import React from 'react';

import PropTypes from 'prop-types';
import { Divider } from '@telus-uds/components-web';

import InfoListRow from './infoListRow';
import { TankDetailsMain } from './css';

const InfoList = ({ tankDetails, setTankDetails }) => {
  return (
    <>
      <Divider space={3} variant={{ inverse: true }} />
      <TankDetailsMain>
        {tankDetails.map((row, index) => (
          <InfoListRow
            key={`InfoListItem-${index + 1}`}
            rowIndex={index}
            row={row}
            tankDetails={tankDetails}
            setTankDetails={setTankDetails}
          />
        ))}
      </TankDetailsMain>
    </>
  );
};

InfoList.propTypes = {
  tankDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
  setTankDetails: PropTypes.func.isRequired
};

export default InfoList;
